import { Navigate, Outlet, useRoutes } from "react-router-dom";
import LoginPage from "../pages/login";
import NotFoundPage from "../pages/404";
import CompactLayout from "../layouts/compact/layout";
import NotAllowedPage from "../pages/403";
import DashboardLayout from "../layouts/dashboard/layout";
import UsersPage from "../pages/users/list";
import AuthMiddleware from "./middlewares/auth";
import CreateUserPage from "../pages/users/create";
import UpdateUserPage from "../pages/users/update";
import BranchesListPage from "../pages/branches/list";
import DepartmentsListPage from "../pages/departments/list";
import SystemPage from "../pages/systems/list";
import SelectSystemPagePage from "../pages/select-system";
import AuthModernCompactLayout from "../layouts/auth/modern-compact";

const SystemRoutes = () => {

    const routes = useRoutes([
        {
            path: '/',
            element: (
                <LoginPage />
            )
        },
        {
            element: (
                <AuthMiddleware>
                    <DashboardLayout>
                        <Outlet />
                    </DashboardLayout>
                </AuthMiddleware>
            ),
            children: [
                {
                    element: <UsersPage />,
                    path: '/users'
                },
                {
                    element: <CreateUserPage />,
                    path: '/users/create'
                },
                {
                    element: <UpdateUserPage />,
                    path: '/users/:id'
                },
                {
                    element: <BranchesListPage />,
                    path: '/branches'
                },
                {
                    element: <DepartmentsListPage />,
                    path: '/departments'
                },
                {
                    element: <SystemPage />,
                    path: '/systems'
                }
            ]
        },

        // ------------------------------------------------

        { // rotas com o compact layout
            element: (
                <CompactLayout>
                    <Outlet />
                </CompactLayout>
            ),
            children: [
                {
                    path: '/404',
                    element: <NotFoundPage />
                },
                {
                    path: '/403',
                    element: <NotAllowedPage />
                },                
            ]
        },

        // rotas com layout compacto moderno
        {
            element: (
                <AuthModernCompactLayout>
                    <Outlet />
                </AuthModernCompactLayout>
            ),
            children: [
                {
                    path: '/select-system',
                    element: (
                        <AuthMiddleware>
                            <SelectSystemPagePage />
                        </AuthMiddleware>
                    )
                },
            ]
        },

        // ------------------------------------------------

        {
            path: '*',
            element: <Navigate to={'/404'} replace />
        }
    ]);

    return routes;

}

export default SystemRoutes;
